<template>
  <div class="medicine-stock-edit-form">
    <v-app>
      <b-form @submit.stop.prevent="formOnsubmit">
        <section class="medicine-stock-edit-form__section">
          <div class="medicine-stock-edit-form__heading">
            <div class="medicine-stock-edit-form__icon"><i class="fas fa-history"></i></div>
            <div>
              <h4>Transaksi stok</h4>
              <p>Data sumber dikunci untuk menjaga jejak audit pergerakan stok.</p>
            </div>
          </div>

          <div class="medicine-stock-edit-form__grid">
            <b-form-group id="edit-input-group-stock-in-out" label="Jenis Stok:" label-for="edit-input-stock-in-out">
              <b-form-select id="edit-input-stock-in-out" v-model="form.stock_in_out" :options="options" disabled></b-form-select>
              <small class="text-danger">{{ error.stock_in_out }}</small>
            </b-form-group>

            <b-form-group id="edit-input-group-medicine" label="Obat dan Alkes:" label-for="edit-input-medicine">
              <b-form-input id="edit-input-medicine" v-model="display.medicine_name" readonly disabled></b-form-input>
              <small class="text-danger">{{ error.medicine_id }}</small>
            </b-form-group>

            <b-form-group id="edit-input-group-quantity" label="Kuantitas Transaksi:" label-for="edit-input-quantity">
              <b-form-input id="edit-input-quantity" v-model="form.quantity" disabled></b-form-input>
              <small class="text-danger">{{ error.quantity }}</small>
            </b-form-group>

            <b-form-group v-if="stock_in" id="edit-input-group-vendor">
              <label>Supplier <em class="text-muted">opsional</em></label>
              <treeselect v-model="form.vendor_id" :multiple="false" :options="vendors" placeholder="Pilih supplier" />
              <small class="text-danger">{{ error.vendor_id }}</small>
            </b-form-group>
          </div>
        </section>

        <section v-if="stock_in" class="medicine-stock-edit-form__section">
          <div class="medicine-stock-edit-form__heading">
            <div class="medicine-stock-edit-form__icon"><i class="fas fa-tags"></i></div>
            <div>
              <h4>Penyesuaian harga</h4>
              <p>Bandingkan nilai lama sebelum menyimpan harga pembelian terbaru.</p>
            </div>
          </div>

          <div class="medicine-stock-edit-form__grid">
            <b-form-group id="edit-input-group-old-price" label="Harga Sebelumnya:" label-for="edit-input-old-price">
              <b-form-input id="edit-input-old-price" v-model="form.display_price" disabled></b-form-input>
            </b-form-group>
            <b-form-group id="edit-input-group-new-price" label="Harga Netto Apotek Baru:" label-for="edit-input-new-price">
              <b-form-input id="edit-input-new-price" v-model="form.price" inputmode="numeric" placeholder="Masukkan harga baru"></b-form-input>
              <small class="text-danger">{{ error.price }}</small>
            </b-form-group>
          </div>
        </section>

        <section class="medicine-stock-edit-form__section">
          <b-form-group id="edit-input-group-notes" class="mb-0">
            <label for="edit-input-notes">Catatan <em class="text-muted">opsional</em></label>
            <b-form-textarea id="edit-input-notes" v-model="form.notes" placeholder="Alasan atau keterangan perubahan" rows="3" max-rows="5"></b-form-textarea>
            <small class="text-danger">{{ error.notes }}</small>
          </b-form-group>
        </section>

        <div class="medicine-stock-edit-form__actions">
          <b-button type="submit" variant="primary"><i class="fas fa-save mr-2"></i>Simpan Perubahan</b-button>
          <b-button variant="default" @click="$router.push('/medicine/maintain-stock')">Batal</b-button>
        </div>
      </b-form>
      <ModalMedicine
        @chosenMedicine="setMedicine"
        secondPurpose="medicineStock"
        :isAbjad="true"
      />
    </v-app>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import ModalMedicine from "@/component/general/ModalMedicine.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "Add",

  props: {
    form: Object,
    route: String,
  },

  components: {
    Card,
    ModalMedicine,
  },

  data() {
    return {
      // Display Data
      display: {
        medicine_name: "",
      },
      medicine: [],
      vendors: [],
      warehouse: [],
      rack: [],
      modal2: false,
      stock_in: true,
      // Error
      error: {
        medicine_id: null,
        medicine_name: "",
        stock_in_out: null,
        quantity: null,
        remaining_stock: null,
        price: null,
        vendor_id: null,
        vendor_name: null,
        notes: "",
        hna: "",
        ppn: "",
        discount: "",
        ref_no: "",
      },
      error_batch: {
        first_quantity: "",
        expired: "",
        warehouse_id: "",
        rack_id: "",
        batch_no: "",
      },
      options: [
        { value: null, text: "Pilih Jenis Stok", disabled: true },
        { value: 0, text: "Stok Masuk" },
        { value: 1, text: "Stok Keluar" },
      ],
      route_vendor: "",
      form_vendor: {
        medicine_id: this.form.medicine_id,
        vendor_id: this.form.vendor_id,
      },
      batch_collection: [],
      batch_collection_form: {
        batch_no: "",
        first_quantity: "",
        warehouse_id: [],
        rack_id: [],
        warehouse_name: "",
        rack_name: "",
        expired: "",
      },
      quantity_count: 0,
      warehouseChoosed: false,
    };
  },

  computed: {
    formatedPrice: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.form.hna = newValue.toLocaleString("id-ID");
        } else {
          this.form.hna = "";
        }
      },
      get() {
        return this.form.hna;
      },
    },
  },

  methods: {
    setMedicine(value) {
      this.form.medicine_id = value.id;
      this.display.medicine_name = value.name;
      this.$bvModal.hide("modal-medicine");
    },

    async getMedicineOption() {
      let response = await module.setTreeSelect("medicines");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.medicine = response.data;
      }
    },
    async getVendorOption() {
      let response = await module.setTreeSelect("vendors");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.vendors = response.data;
      }
    },
    async getWarehouseOption() {
      let response = await module.setTreeSelect("warehouses");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.warehouse = response.data;
      }
    },
    async getRackOption(id) {
      let response = await module.setTreeSelect("warehouses-rack/" + id);
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.rack = response.data;
        this.warehouseChoosed = true;
      }
    },

    setFormStockInOut() {
      if (this.stock_in == true) {
        this.stock_in = false;
      } else if (this.stock_in == false) {
        this.stock_in = true;
      }
    },

    resetBatchForm() {
      // Object.keys(this.batch_collection_form).forEach(function (key, index) {
      //     this.batch_collection_form[key] = "";
      // });
      this.batch_collection_form.first_quantity = "";
      this.batch_collection_form.expired = "";
      this.batch_collection_form.batch_no = "";
      this.batch_collection_form.warehouse_id = null;
      this.batch_collection_form.rack_id = null;

      this.batch_collection_form.warehouse_name = null;
      this.batch_collection_form.rack_name = null;

      this.batch_collection_form.warehouse = null;
      this.batch_collection_form.rack = null;
    },
    async setBatch() {
      if (
        this.batch_collection_form.first_quantity == "" ||
        this.batch_collection_form.expired == "" ||
        this.batch_collection_form.batch_no == "" ||
        this.batch_collection_form.warehouse_id == "" ||
        this.batch_collection_form.rack_id == ""
      ) {
        if (this.batch_collection_form.first_quantity == "") {
          this.error_batch.first_quantity = "Jumlah tiap batch harus diisi";
        }
        if (this.batch_collection_form.batch_no == "") {
          this.error_batch.batch_no = "Nomer batch harus diisi";
        }
        if (this.batch_collection_form.expired == "") {
          this.error_batch.expired = "Tanggal kadaluarsa harus diisi";
        }
      } else {
        this.error_batch.first_quantity = "";
        this.error_batch.batch_no = "";
        this.error_batch.expired = "";
        this.error_batch.warehouse_id = "";

        if (this.batch_collection.length == 0) {
          this.quantity_count =
            this.quantity_count +
            parseInt(this.batch_collection_form.first_quantity);
          if (this.quantity_count <= this.form.quantity) {
            let response = await module.get(
              `warehouses/${this.batch_collection_form.warehouse_id}`
            );
            this.batch_collection_form.warehouse_name = response.name;
            let resRack = await module.get(
              `warehouses-rack/by-id/${this.batch_collection_form.rack_id}`
            );
            this.batch_collection_form.rack_name = resRack.name;

            let clone = { ...this.batch_collection_form };
            this.batch_collection.push(clone);
            this.resetBatchForm();
          } else {
            Swal.fire({
              title: "Gagal",
              text: "Jumlah stok batch tidak boleh melebihi kuantitas obat",
              icon: "warning",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.quantity_count =
              this.quantity_count -
              parseInt(this.batch_collection_form.first_quantity);
          }
        } else {
          let a;
          for (a = 0; a < this.batch_collection.length; a++) {
            if (
              this.batch_collection_form.batch_no ==
              this.batch_collection[a].batch_no
            ) {
              Swal.fire({
                title: "Gagal",
                text: "Batch No Tidak Boleh Sama",
                icon: "warning",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            } else {
              // this.form.quantity = parseInt(this.form.quantity) + parseInt(this.batch_collection_form.first_quantity)
              this.quantity_count =
                this.quantity_count +
                parseInt(this.batch_collection_form.first_quantity);
              if (this.quantity_count <= this.form.quantity) {
                let clone = { ...this.batch_collection_form };
                this.batch_collection.push(clone);
                this.resetBatchForm();
                break;
              } else {
                Swal.fire({
                  title: "Gagal",
                  text: "Jumlah stok batch tidak boleh melebihi kuantitas obat",
                  icon: "warning",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
                this.quantity_count =
                  this.quantity_count -
                  parseInt(this.batch_collection_form.first_quantity);
              }
            }
          }
        }
      }
    },
    removeBatch($id) {
      let a;
      for (a = 0; a < this.batch_collection.length; a++) {
        if (this.batch_collection[a].batch_no == $id) {
          this.quantity_count =
            this.quantity_count -
            parseInt(this.batch_collection[a].first_quantity);
          this.batch_collection.splice(a, 1);
        }
      }
    },

    priceOnKeyup(evt) {
      this.form.hna = parseInt(this.form.hna).toLocaleString("id-ID");
    },

    async getItem() {
      let response = await module.get(
        `medicine-stocks/${this.$route.params.id}`
      );

      this.display.medicine_name = response.medicine_name;
    },

    async formOnsubmit() {
      // Make Request
      let response = await module.submit(this.form, this.route);
      // Check Response
      if (response.state == "error") {
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        Swal.fire(response.success.title, response.success.message, "success");
        this.$router.push("/medicine/maintain-stock");
      }
    },
  },

  mounted() {
    this.getMedicineOption();
    this.getVendorOption();
    this.getWarehouseOption();
    this.getItem();
  },
  watch: {
    "form.medicine_name": function (newVal, oldVal) {
      this.display.medicine_name = newVal;
    },
    "batch_collection_form.warehouse": function (newVal) {
      this.batch_collection_form.warehouse_id = newVal;
      this.getRackOption(newVal);
    },
    "batch_collection_form.rack": function (newVal) {
      this.batch_collection_form.rack_id = newVal;
    },
  },
};
</script>

<style scoped>
.medicine-stock-edit-form__section {
  margin-bottom: 18px;
  padding: 18px;
  border: 1px solid #dfe8ee;
  border-radius: 13px;
  background: #fff;
}

.medicine-stock-edit-form__heading {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 16px;
  padding-bottom: 13px;
  border-bottom: 1px solid #e7eef3;
}

.medicine-stock-edit-form__heading h4,
.medicine-stock-edit-form__heading p {
  margin: 0;
}

.medicine-stock-edit-form__heading h4 {
  color: #1f3449;
  font-size: 14px;
  font-weight: 700;
}

.medicine-stock-edit-form__heading p {
  margin-top: 3px;
  color: #718295;
  font-size: 11px;
}

.medicine-stock-edit-form__icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  place-items: center;
  border-radius: 10px;
  color: #0f8881;
  background: #e7f6f4;
}

.medicine-stock-edit-form__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2px 18px;
}

.medicine-stock-edit-form__grid > fieldset,
.medicine-stock-edit-form__grid > .form-group {
  min-width: 0;
  margin-bottom: 14px;
}

.medicine-stock-edit-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding-top: 2px;
}

@media (max-width: 767.98px) {
  .medicine-stock-edit-form__section {
    padding: 14px;
  }

  .medicine-stock-edit-form__grid {
    display: block;
  }

  .medicine-stock-edit-form__actions {
    flex-direction: column;
  }

  .medicine-stock-edit-form__actions .btn {
    width: 100%;
  }
}
</style>
